const creativeCreations = [
  {
    title: 'Publicidad digital',
    items: [
      'Campañas de anuncios en Facebook y redes sociales',
      'Publicidad en Google Display',
      'Creatividades programáticas',
      'Variaciones de anuncios con pruebas A/B'
    ]
  },
  {
    title: 'Web y landing pages',
    items: [
      'Diseño de páginas de destino de alta conversión',
      'Páginas de presentación de productos',
      'Micrositios específicos de campaña',
      'Diseños responsivos y optimizados para móvil'
    ]
  },
  {
    title: 'Marca y campañas',
    items: [
      'Sistemas completos de identidad de marca',
      'Conceptos de campaña y dirección creativa',
      'Materiales de marketing y ventas',
      'Guías de marca y bibliotecas de recursos'
    ]
  },
  {
    title: 'Exterior',
    items: [
      'Diseño de vallas publicitarias',
      'Publicidad en transporte público',
      'Señalización y gráficos ambientales',
      'Diseño para impresión de gran formato'
    ]
  }
];

const creativeProcessSteps = [
  { number: '01', title: 'Desarrollo de concepto', text: 'Conceptos creativos estratégicos alineados a tus objetivos' },
  { number: '02', title: 'Diseño y producción', text: 'Ejecución profesional en todos los formatos' },
  { number: '03', title: 'Coordinación de medios', text: 'Apoyo en estrategia de compra y ubicación' },
  { number: '04', title: 'Seguimiento de desempeño', text: 'Analítica y optimización para máximo impacto' },
  { number: '05', title: 'Ejecución multicanal', text: 'Campañas coherentes en todos los puntos de contacto' }
];

const developmentBuilds = [
  {
    title: 'Sistemas financieros que no titubean',
    items: [
      'Motores de pago de nivel bancario',
      'Plataformas de criptomonedas y activos digitales',
      'Sistemas de trading de Bitcoin antes de que fueran tendencia',
      'Redes de transacciones en tiempo real reforzadas contra abuso, escala y auditorías'
    ]
  },
  {
    title: 'Plataformas de salud que sostienen clínicas',
    items: [
      'Infraestructuras EHR de extremo a extremo',
      'Redes de proveedores multi clínica y multiestado',
      'Todo lo relacionado con historiales, facturación, agenda y PHI seguro',
      'Gestión integral de consultorios para clínicas reales'
    ]
  },
  {
    title: 'Sistemas empresariales y gubernamentales sin margen de error',
    items: [
      'Plataformas de gestión de bonos y subvenciones',
      'Sistemas de supervisión de programas de construcción',
      'Seguimiento financiero y de proyectos a nivel distrital',
      'Automatización operativa, CRM y flujos de trabajo a medida'
    ]
  },
  {
    title: 'Comunicaciones cifradas antes de que la privacidad fuera tendencia',
    items: [
      'Plataformas de mensajería encriptada',
      'Sistemas de correo seguro basados en PGP',
      'Redes privadas de comunicación organizacional'
    ]
  },
  {
    title: 'Tecnología emergente antes de que emergiera',
    items: [
      'Integraciones de IA y aprendizaje automático',
      'Plataformas autónomas e IoT',
      'Arquitecturas distribuidas en tiempo real',
      'Sistemas de alto rendimiento para tecnologías de hardware e interfaz'
    ]
  }
];

const developmentWhyBullets = [
  'No vivimos de la nostalgia: mostramos las pruebas.',
  'Cada app, automatización, interfaz y sistema que construimos hoy está respaldado por un cuarto de siglo de cicatrices, triunfos, giros y noches sin dormir en producción.',
  'No estás contratando un taller de devs; traes a un equipo de élite con experiencia que no se puede fingir.'
];

const es = {
  layout: {
    title: 'TX Fortress Music',
    description: 'Texas Fortress AI convierte ideas en código listo para producción de forma rápida y segura.'
  },
  languageSwitcher: {
    en: 'EN',
    es: 'ES',
    ariaLabel: 'Cambiar idioma'
  },
  menu: {
    home: 'Inicio',
    news: 'Noticias',
    development: 'Desarrollo',
    creative: 'Creatividad',
    music: 'Música',
    charity: 'Caridad',
    about: 'Acerca de'
  },
  legal: {
    openSource: '— Código abierto por colaboradores —'
  },
  notFound: {
    title: 'No encontrado',
    description: 'La ubicación que buscas no se encontró en el sistema.',
    goToStart: 'Ir al inicio'
  },
  home: {
    welcome: 'Bienvenido.'
  },
  about: {
    title: 'Acerca de Soul Extract',
    intro: 'Cerebral. Hermoso. Violento. Soul Extract aprovecha un amplio espectro de emociones y experiencias humanas para crear un espacio sonoro tan intenso e impredecible como la vida misma. La inspiración profundamente personal detrás de las creaciones de Soul Extract aporta a cada canción un nivel vigorizante de claridad creativa, y la disposición del artista a romper barreras de género lo coloca a la vanguardia de la música moderna.',
    imageAlt: 'Foto de Josh Mullis',
    second: 'Aunque el enfoque estilístico de Soul Extract encaja en el amplio espectro del rock electrónico, las etiquetas no alcanzan a describir la naturaleza exploratoria, casi progresiva, de las canciones. Josh Mullis, el arquitecto detrás de las elaboradas composiciones de Soul Extract, aplica una mentalidad deconstructiva a su oficio, desarmando géneros y fusionando sus elementos más atractivos para construir pistas calculadas y detalladas.',
    albumAlt: 'Álbum Circadian Algorithm de Soul Extract',
    lowerParagraphs: [
      'Este enfoque analítico de Soul Extract comenzó a tomar forma en 2013 y, tras años de sintetizar sonidos de metal, música electrónica y orquestal, el artista lanzó su ardiente álbum debut, Circadian Algorithm. Repleto de voces emotivas y secciones instrumentales explosivas, el álbum sentó las bases para una carrera en desarrollo con una trayectoria ascendente.',
      'La pasión de Mullis por la música comenzó a temprana edad y siempre ha extraído inspiración de eventos profundamente personales. Encontró refugio de las dificultades familiares al tomar una guitarra cuando era adolescente y descubrió que esos primeros esfuerzos creativos lo ayudaban a atravesar tiempos impredecibles. Ya de adulto, su motivación se apoya en causas humanitarias, pues dona parte de las ganancias de Soul Extract a New Day Foster Home (www.newdayfosterhome.com), una organización que apoyó la salud de su hija adoptiva en sus primeros años.',
      'Para Mullis, la música es una fuerza indescriptible capaz de despertar emociones intensas, y esta fuerza es la esencia del artista en su forma más pura. Como sugiere el nombre del proyecto, Soul Extract es la expresión sin filtro de Josh Mullis, y su enfoque apasionado de la composición brilla en cada pista que produce.'
    ],
    sourceLabel: 'Fuente:',
    sourceLinkText: 'fixtonline.com/label/artists/soul-extract'
  },
  charity: {
    title: 'Donación a obras benéficas',
    intro: 'La música siempre ha sido una plataforma para que los artistas apoyen y den visibilidad a causas cercanas a su corazón. A través de sus creaciones, innumerables músicos consolidados y emergentes han usado el poder de un público para impulsar la conciencia social de causas que, de otro modo, podrían pasar desapercibidas.',
    familyAlt: 'Familia de Josh Mullis',
    cause: {
      prefix: 'Para Josh Mullis de Soul Extract esa causa es',
      linkLabel: 'New Day Foster Home',
      suffix: ', una organización sin fines de lucro con sede en China que brinda “cirugías que salvan vidas y un hogar amoroso” a niños huérfanos desde finales de 2000. La familia Mullis se involucró con New Day en 2011 cuando tomó la decisión que cambiaría sus vidas de adoptar a una niña de China, que en ese momento seguía bajo la estricta “ley de un solo hijo”.'
    },
    fosterHomeAlt: 'New Day Foster Home',
    quoteIntro: [
      'Para Josh Mullis de Soul Extract esa causa es New Day Foster Home, una organización sin fines de lucro con sede en China que brinda “cirugías que salvan vidas y un hogar amoroso” a niños huérfanos desde finales de 2000. La familia Mullis se involucró con New Day en 2011 cuando tomó la decisión que cambiaría sus vidas de adoptar a una niña de China, que en ese momento seguía bajo la estricta “ley de un solo hijo”.',
      'Ansley nació con mielomeningocele, la forma más grave de espina bífida. Este defecto afecta la columna y la médula espinal y muchos niños terminan incontinentes o sin poder caminar. Ahora vive una vida feliz y normal gracias a New Day Foster Home.'
    ],
    enlarging: 'Al ampliar su familia, los Mullis también ampliaron su horizonte y Josh se inspiró para orientar su arte hacia el bien común,',
    quoteTwo: 'Toda la experiencia me inspiró a dedicar mi proyecto musical a esta organización de cualquier manera posible. Ya sea donando parte de las ganancias o patrocinando a un niño.',
    albumParagraph: 'Con un nuevo álbum, Circadian Algorithm, que sale la próxima semana (13 de noviembre), el cielo es el límite para Soul Extract/Mullis, quien atribuye sus esfuerzos humanitarios como fuente constante de motivación:',
    quoteThree: 'Cuando me frustro con el proceso de creación musical, esto me mantiene en marcha y le da un sentido de propósito a este proyecto.',
    involvement: 'Si los fans de Soul Extract quieren involucrarse con New Day Foster Home, Mullis tiene algunas ideas:',
    quoteFour: [
      'Para empezar, si estás escuchando Circadian Algorithm en plataformas de streaming o lo has comprado, ya estás ayudando a New Day porque parte de las ganancias se envían directamente a ellos. También tienen una cuenta genial de Instagram (@newdaycharities), donde publican con regularidad las actividades con los niños, actualizaciones de cirugías, etc.',
      'Diría que ese es un buen punto de partida y, si sientes el llamado, tienen una página de donaciones aquí:'
    ],
    fosterLogoAlt: 'Logotipo de New Day Foster Home',
    closing: 'Estamos orgullosos de apoyar a Soul Extract a través de Texas Fortress AI y de impulsar sus esfuerzos para hacer del mundo un lugar mejor, un álbum a la vez.',
    sourceLabel: 'Fuente:',
    sourceLinkText: 'texasfortress.ai'
  },
  music: {
    missing: 'No se encontraron archivos de audio. Agrega pistas en static/music para poblar esta página.',
    selectTrack: 'Selecciona cualquier sencillo para iniciar la reproducción.',
    play: '▶ REPRODUCIR',
    pause: '⏸ PAUSA',
    unknownArtist: 'Artista desconocido'
  },
  news: {
    title: 'Noticias',
    seeMore: 'Ver más en',
    facebookCta: 'facebook.com/soulextract.'
  },
  creative: {
    metaTitle: 'Creatividad - Texas Fortress AI',
    metaDescription: 'Servicio creativo integral para marcas que exigen impacto: anuncios, landing pages, sistemas de marca y campañas que convierten.',
    heroTitle: 'Ideas que capturan la atención',
    heroSubtitle: 'Agencia creativa integral para marcas que exigen impacto',
    introTitle: 'Creatividad que convierte',
    introText: `Desde el concepto hasta la campaña, creamos experiencias visuales que detienen el scroll, capturan la atención y generan resultados.
No somos solo diseñadores: somos socios estratégicos que entienden que una gran creatividad sirve a tus objetivos de negocio.`,
    creationsTitle: 'Lo que creamos',
    strategyTitle: 'Estrategia y diseño',
    strategyText: `Cada píxel tiene un propósito. Combinamos potencia creativa con estrategia basada en datos para entregar campañas que
no solo se ven bien, sino que funcionan. Ya sea una renovación completa de marca o un anuncio ganador, aplicamos el mismo nivel de oficio y pensamiento estratégico.`,
    processTitle: 'Gestión integral de campañas',
    ctaText: 'Creemos algo memorable: abre el chat para empezar ahora.',
    creations: creativeCreations,
    processSteps: creativeProcessSteps
  },
  development: {
    metaTitle: 'Desarrollo - Texas Fortress AI',
    metaDescription: 'Construimos las soluciones del mañana hoy: software seguro y listo para producción, de la IA a la infraestructura.',
    heroTitle: 'Construyendo las soluciones del mañana hoy',
    heroSubtitle: '25 años de excelencia en ingeniería en cada frontera del software',
    resumeTitle: 'Nuestro historial comprobado',
    resumeParagraphs: [
      'No empezamos ayer a escribir software. Nos ganamos las insignias en 25 años de guerras de ingeniería reales: lanzando sistemas que otros equipos no tocarían, resolviendo problemas que las grandes firmas dejaron atrás y entregando plataformas en producción antes de que la "cultura startup" supiera deletrear MVP.',
      'Esto no es una lista de lo que vendemos hoy. Es nuestro currículum de lo imposible: la prueba detrás de cada promesa que hacemos ahora.'
    ],
    buildsTitle: 'Lo que hemos construido cuando más importaba',
    builds: developmentBuilds,
    whyTitle: 'Por qué importa hoy',
    whyBullets: developmentWhyBullets,
    cta: '¿Listo para construir algo extraordinario? Inicia un chat con nosotros.'
  }
};

export default es;
